export const SERVER_CONF = {
	BASE_PATH: '/api'
}